import { DashboardTitle } from 'components/Dashboard/DashboardTitleContext'
import PageComponent from 'components/Dashboard/PageComponent'
import FailedTdlResults from './FailedTdlResults'

const TDL: PageComponent = () => {
  return (
    <div className="container">
      <DashboardTitle title="TDL" />

      <FailedTdlResults />
    </div>
  )
}

TDL.path = '/tdl'
TDL.displayName = 'TDL'

export default TDL
